<template>
	<material-popup :dialogShowModel="showAttachmentList" v-if="popup">
		<material-card icon="fas fa-paperclip" :title="computedLabel" :main_action="main_action" @mainAction="addNewAttachment" noduplicate :selected="selected_attachment" @unselectAll="selected_attachment = []" :fullscreenadapter="$vuetify.breakpoint.xsOnly" dismissable @dismissed="showAttachmentList = false">
			<template slot="selection-actions">
				<v-btn class="ma-1 mr-0" @click="deleteAttachment()" small outlined :disabled="attachment_loading" :loading="attachment_loading">
					{{ $t("global.delete") }}
					<v-icon small class="pl-1">far fa-trash-alt</v-icon>
				</v-btn>
			</template>
			<template slot="filters">
				<v-col cols="12" xs="12" sm="6">
					<search-box v-model="attachment_options.search" nocolor @change="attachment_options.page = 1"></search-box>
				</v-col>
			</template>
			<material-table id="#attachment" @click-action="editAttachment" :selected.sync="selected_attachment" show-select :headers="attachment_headers" :items="attachment.data" :options.sync="attachment_options" :server-items-length="attachment.total" :loading="attachment_loading">
				<template v-slot:item.created_at="{ item }">{{ $formatters.frontEndDateFormat(item.created_at) }}</template>
				<template v-slot:item.filesize="{ item }">{{ $formatters.fileSize(item.filesize) }}</template>
				<template v-slot:item.filetype="{ item }"><download-attachment action="view" :element="item"></download-attachment></template>
			</material-table>
			<template slot="actions">
				<v-col cols="6" xs="6" sm="3">
					<action-button large @click="showAttachmentList = false" color="success" :text="'Ok'"></action-button>
				</v-col>
			</template>
		</material-card>
		<create-edit-attachment v-if="showCreateEditAttachment"></create-edit-attachment>
	</material-popup>
	<main-container class="pa-0 ma-0" v-else>
		<material-card icon="fas fa-paperclip" :title="computedLabel" :main_action="main_action" @mainAction="addNewAttachment" noduplicate :selected="selected_attachment" @unselectAll="selected_attachment = []">
			<template slot="delete-actions">
				<v-btn icon light link @click="deleteAttachment()">
					<v-icon>far fa-trash-alt</v-icon>
				</v-btn>
			</template>
			<template slot="filters">
				<v-col cols="12" xs="12" sm="6">
					<search-box v-model="attachment_options.search" nocolor @change="attachment_options.page = 1"></search-box>
				</v-col>
			</template>
			<material-table id="#attachment" @click-action="editAttachment" :selected.sync="selected_attachment" show-select :headers="attachment_headers" :items="attachment.data" :options.sync="attachment_options" :server-items-length="attachment.total" :loading="attachment_loading">
				<template v-slot:item.created_at="{ item }">{{ $formatters.frontEndDateFormat(item.created_at) }}</template>
				<template v-slot:item.filesize="{ item }">{{ $formatters.fileSize(item.filesize) }}</template>
				<template v-slot:item.filetype="{ item }"><download-attachment action="view" :element="item"></download-attachment></template>
			</material-table>
		</material-card>
		<create-edit-attachment v-if="showCreateEditAttachment"></create-edit-attachment>
	</main-container>
</template>

<script>
export default {
	data: () => ({
		originalattachment_options: null,
		selected_attachment: [],
		description: null,
		title: null,
	}),
	props: {
		popup: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		main_action() {
			return {
				icon: "fas fa-plus",
				text: this.$t("attachment.add_attachment"),
			};
		},
		computedLabel() {
			let label = this.$t("attachment.list_title");
			if (this.$store.getters.getAttachmentCategory) {
				switch (this.$store.getters.getAttachmentCategory) {
					case "incomedeclarations":
						label = this.$t("incomedeclarations.attachments");
						break;
					case "adminincomedeclarations":
						label = this.$t("incomedeclarations.attachments");
						break;
					default:
						break;
				}
			}
			return label;
		},
		showAttachmentList: {
			get: function () {
				return this.$store.getters.showAttachmentList;
			},
			set: function (value) {
				if (!value) {
					this.$store.dispatch("hideAction", "hideAttachmentList");
				}
			},
		},
		attachment_options: {
			get: function () {
				return this.$store.getters.getAttachmentOptions;
			},
			set: function (value) {
				this.$store.commit("setAttachmentOptions", value);
			},
		},
		attachment_headers() {
			let headers = [];
			headers.push({
				text: this.$t("attachment.created_at"),
				value: "created_at",
				align: "left",
				sortable: true,
				width: "1%",
				selected: true,
			});
			headers.push({
				text: this.$t("attachment.filecategory"),
				value: "filecategory",
				align: "left",
				sortable: false,
				selected: true,
			});
			headers.push({
				text: this.$t("attachment.file_title"),
				value: "title",
				align: "left",
				sortable: true,
				selected: true,
			});
			headers.push({
				text: this.$t("attachment.filesize"),
				value: "filesize",
				align: "left",
				sortable: true,
				width: "1%",
				selected: true,
			});
			headers.push({
				text: "",
				value: "filetype",
				align: "left",
				sortable: true,
				width: "1%",
				selected: true,
			});
			return { data: headers, id: "attachment_headers" };
		},
		attachment_loading() {
			return this.$store.getters.attachment_loading;
		},
		attachment() {
			return this.$store.getters.getAttachment;
		},
		showCreateEditAttachment() {
			return this.$store.getters.showCreateEditAttachment;
		},
	},
	methods: {
		addNewAttachment() {
			let current = _.cloneDeep(this.$store.getters.getCurrentAttachmentModel);
			current.attachments = [];
			this.$store.commit("setCurrentAttachmentModel", current);
			this.$store.dispatch("showAction", "showAttachment");
		},
		editAttachment(item) {
			this.$store.commit("setCurrentAttachment", item);
			this.$store.dispatch("showAction", "showCreateEditAttachment");
		},
		deleteAttachment() {
			const self = this;
			let message = self.$t("global.delete_confirm_message_pre");
			if (self.selected_attachment.length <= 1) {
				message += self.$t("attachment.question_selected");
			} else {
				message += self.selected_attachment.length + self.$t("attachment.question_multiple_selected");
			}
			self.$store.commit("showDialog", {
				type: "confirm",
				title: self.$t("global.delete_confirm_title"),
				message: message,
				okCb: () => {
					self.selected_attachment.forEach((element) => {
						self.$store.dispatch("deleteAttachment", element.id).then((res) => {
							self.$functions.actionOnSelection(res, self.selected_attachment);
						});
					});
				},
			});
		},
		loadAttachment() {
			if (!this.$functions.ObjectAreEqual(this.originalattachment_options, this.attachment_options)) {
				this.originalattachment_options = _.cloneDeep(this.attachment_options);
				this.$store.dispatch("fetchAttachment");
			}
		},
	},
	watch: {
		attachment_options: {
			handler() {
				this.loadAttachment();
			},
			deep: true,
		},
	},
	mounted() {
		if (this.$store.getters.getAttachmentCategory) {
			switch (this.$store.getters.getAttachmentCategory) {
				case "incomedeclarations":
					this.attachment_options.model_type = "incomedeclarations";
					this.attachment_options.model_id = this.$store.getters.getCurrentIncomeDeclarations.id;
					break;
				case "adminincomedeclarations":
					this.attachment_options.model_type = "adminincomedeclarations";
					this.attachment_options.model_id = this.$store.getters.getCurrentAdminIncomeDeclarations.id;
					break;
				default:
					this.attachment_options.model_type = null;
					this.attachment_options.model_id = null;
					break;
			}
		} else {
			switch (this.$route.name) {
				case "incomedeclarations":
					this.attachment_options.model_type = "incomedeclarations";
					this.attachment_options.model_id = this.$store.getters.getCurrentIncomeDeclarations.id;
					break;
				case "adminincomedeclarations":
					this.attachment_options.model_type = "adminincomedeclarations";
					this.attachment_options.model_id = this.$store.getters.getCurrentAdminIncomeDeclarations.id;
					break;
				default:
					this.attachment_options.model_type = null;
					this.attachment_options.model_id = null;
					break;
			}
		}
		this.attachment_options.page = 1;
	},
};
</script>
